import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import css from './Users.css'

const EditUserListItem = ({ toggleEditModal, user: { email }, user }) => (
  <li className={css.user}>
    <Button
      type="ghost"
      icon="edit"
      size="small"
      className={css.editIcon}
      onClick={() => {
        toggleEditModal(user)
      }}
    />
    <span>{email}</span>
  </li>
)

EditUserListItem.propTypes = {
  toggleEditModal: PropTypes.func.isRequired,
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
}

export default EditUserListItem



// WEBPACK FOOTER //
// ./src/AddPractice/Users/EditUserListItem.js